import TEditor from "./src/index.vue";
export default TEditor;